<template class="">

      <div>
        
        <v-row>
            <!-- Coluna da esquerda -->
            <v-col cols="12" md="6" class="events-left-column">
              
                <div class="add-event">
                  <v-btn fab dark x-large @click="addEvent" class="add-event-btn">
                    <v-icon :style="{ color: 'rgb(233, 207, 237)' }">mdi-plus</v-icon>
                  </v-btn>
                  <h1 class="event-title"> <strong> novo evento </strong></h1>
                </div>
                <div class="fade d-sm-none"></div> 

              <!-- Lista de Eventos -->
              <div class="events-list mb-16 pb-16">
                <EventsList :events="allEvents" @editEvent="goEditEvent" @eventDeleted="reloadAfterDel"/>
              </div>
                
            </v-col>

            <!-- Coluna da direita -->
            <v-col cols="12" md="6" class="events-right-column d-none d-md-flex">
            <v-img
              src="@/assets/papelEventos1.png"
              alt="Imagem de Login"
              max-width="100%"
              height="auto"
              contain
              class="img_size"
            />
          </v-col>
        </v-row>
        <ErrorSnackbar v-model="error.show" :message="error.message"/>
       
      </div>

</template>

<script>

import EventsList from '@/components/events/EventsList.vue';
import ErrorSnackbar from '@/components/ui/ErrorSnackbar.vue';

import Events from '@/api/Events.js';


export default {
  components: {
    EventsList,
    ErrorSnackbar
  },

  data() {
    return {
      error:{
        show: false,
        message: null
      },
      events: [],
      mediaType: 'image',
      //mediaSrc: require('@/assets/sample.jpg')
    };
  },
  methods: {
    addEvent() {
      this.$router.push({ name: 'EventsCreate'})
    },

    goEditEvent(event) {
      if (event.closed) {
        this.$notify({
          group: 'foo',
          type: 'warn',
          title: 'Evento Encerrado',
          text: '!! Este evento está encerrado !!'
        });
        setTimeout(() => {
          this.$router.push({ name: 'Home' });
        }, 3000); // Redireciona após 3 segundos
      } else {
        this.$router.push({ name: 'EventView', params: { id: event.id } });
      }
    },
  
    async getEvents() {
      try {
        const response = await Events.getByUser();
        this.events = response.data; 

        console.log(localStorage['was_closed'])
        if(localStorage['was_closed'] != undefined){
          this.error.message = 'O evento que tentou aceder já se encontra fechado'
          this.error.show = true
          localStorage.removeItem('was_closed');
        }else{
          this.error.show = false
        }

        console.log('Eventos:', this.events);

      } catch (error) {
        console.error('Erro ao carregar eventos:', error);
      }
    },

    reloadAfterDel() {
      this.getEvents();
    }
},

  created() {
    this.getEvents();
  },

  computed: {
    allEvents() {
      return [...this.events]; // Junta os arrays
    }
  }

};
</script>

<style scoped>
section {
  overflow: hidden;
}

.add-event {
  display: flex;
  justify-content: flex-start; /* Alinha mais à esquerda */
}

.media-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.event-container {
  display: flex;
  align-items: center;
}

.event-card {
  flex: 1;
  border-radius: 20px;
  padding: 15px;
  background: white;
  border: 1px solid transparent;
}

.event-card.closed {
  border: 2px solid black;
  background: transparent;
}

.event-content {
  display: flex;
  flex-direction: column;
}

.event-title {
  font-size: 18px;
}

.participants {
  font-weight: bold;
}

.event-description {
  font-size: 14px;
  color: gray;
}

/* Botão de apagar à direita do evento */
.delete-btn {
  margin-left: 10px;
  color: black !important;
}

.closed-date {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin-top: 10px;
}

.event-title {
  margin-left: 20px; 
  margin-top: 25px;
}

.events-right-column {
  display: flex;
  justify-content: center; 
  align-items: center;
  height: 100dvh;
  position: fixed;
  right: 0;
  top: 0;
  width: 59%;
  padding: 30px;
  margin-right: 30px;
}

.img_size {
  width: 600px !important;
  height: 600px !important;
}

.events-left-column {
  display: flex;
  flex-direction: column;
  justify-content: top;
  padding: 30px;
  margin-left: 50px;
  margin-top: 40px;
  margin-bottom: 150px;
  height: 100dvh;
  overflow-y:auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.add-event-btn {
  margin-bottom: 30px;
}

.events-list {
  padding-top: 30px;
  position: relative;
  margin-bottom: 50px;
  max-height: 68vh;
  overflow-y: auto;
  padding-bottom: 30px;
  position: relative;
  z-index: 4;
}

::-webkit-scrollbar-track {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

::-webkit-scrollbar {
  width: 8px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border-radius: 10px;
}

.fade {
  margin-top: 70px;
  position: absolute; 
  left: 0;
  width: 100%;
  height: 30px; 
  background: linear-gradient(to bottom, rgba(233, 207, 237, 1), rgba(233, 207, 237, 0.2) 100%, transparent 100%); 
  z-index: 5;
}

@media (max-width: 768px) {
  .events-right-column {
    display: none !important;
  }

  .events-left-column {
    padding: 50px;
    margin-left: 0;
    margin-top: 0;
  }

  .add-event-btn {
    margin-bottom: 0px;
  }

  .event-title {
    margin-top: 0px;
    margin-left: 10px;
  }

  .add-event {
    align-items: center;
    margin-bottom: 20px;
  }

  .v-btn--is-elevated.v-btn--fab {
    box-shadow: none;
    height: 50px;
    width: 50px;
  }

  .events-list {
    scrollbar-width: none; /* Esconde a barra de rolagem no Firefox */
    -ms-overflow-style: none; /* Esconde a barra no Edge */
  }

  .events-list::-webkit-scrollbar {
    display: none;
  }
}

@media (max-width: 979px) {
    .events-right-column {
      display: none !important;
    }

}
</style>
